import { Button } from "@blueprintjs/core";
import { useRef } from "react";
interface IProps {
  text?: string;
  icon?: string;
  handleAdd: (file: File) => void;
  className?: string;
}
export default function CsvImportButton({
  text = "Import CSV",
  icon,
  handleAdd,
  className,
}: IProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      handleAdd(file);
    }
  };
  return (
    <>
      <Button
        className={className}
        icon={icon}
        text={text}
        onClick={openFilePicker}
      />

      <input
        ref={fileInputRef}
        type="file"
        accept=".csv"
        style={{ display: "none" }}
        onChange={onChange}
      />
    </>
  );
}
